import analytics from "web/script/analytics/analytics";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption, InputFilterOption } from "web/types/universal-filters";
import styles from "./back-filter-item.css";

interface BackFilterItemProps extends StandardFilterProps {
    item: InputFilterOption | CategoryFilterOption;
    isSmallItem?: boolean;
    hasChildren?: boolean;
    ariaControls?: string;
    siblingOpen?: boolean;
    title: string;
}

function BackFilterItem({
    ariaControls,
    item,
    onClick,
    pendingFilterInfo,
    hasChildren,
    title,
}: BackFilterItemProps): JSX.Element {
    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        analytics.event("filter_ux", "click", "more_button");
        onClick(item);
    }

    let checked = pendingFilterInfo.getChecked(item);

    return (
        <a
            href={item.url}
            className={styles.filterItem}
            onClick={handleClick}
            role="button"
            aria-expanded={hasChildren ? checked : undefined}
            aria-controls={hasChildren ? ariaControls : undefined}
        >
            {!checked ? (
                <SVGIcon className={styles.icon} name={"round-radiobutton-checked"} />
            ) : (
                <SVGIcon className={styles.icon} name={"round-radiobutton"} />
            )}
            <span className={styles.labelItem}>{title}</span>
        </a>
    );
}

export default BackFilterItem;
